import { USE_FRENCH_URL } from './';

export const FR = {
    HOME_PATH: '/',
    HOW_IT_WORK_PATH: '/comment-ca-marche',

    FAQ_PATH: '/faq',
    LEGAL_NOTICE_PATH: '/mentions-legales',
    TERMS_PATH: '/conditions-generales-utilisation',
    TERMS_OF_SALES: '/conditions-generales-vente',
    CONTACTREQUEST_PATH: '/service-client',
    UNSUBSCRIBE_PATH: '/desabonnement',
    TOOLBAR_PATH: '/alerte-bons-plans',
    TOOLBAR_POST_INSTALL_PATH: '/toolbar/post-install',
    MOBILE_APP_PATH: '/appli_mobile',

    ACCOUNT_PATH: '/compte',
    ACCOUNT_JACKPOT_PATH: '/compte/cagnotte-cashback',
    ACCOUNT_MESSAGES_PATH: '/compte/mes-messages',
    ACCOUNT_EBONS_PATH: '/compte/mes-bons-d-achat',
    ACCOUNT_PROFILE_PATH: '/compte/mon-profil',

    EBONS_REMINDER_PATH: '/mes-bons-d-achat',

    ONLINE: 'en-ligne',
    OFFLINE: 'en-magasin',
    EBON: 'bon-achat',

    INTERSTITIEL_CASHBACK_PATH: '/interstitiel/cashback/',
    INTERSTITIEL_TOOLBAR_CASHBACK_PATH: '/toolbar/interstitiel/cashback/',
    INTERSTITIEL_REDUCTION_PATH: '/interstitiel/code-promo/',
    INTERSTITIEL_TOOLBAR_REDUCTION_PATH: '/toolbar/interstitiel/code-promo/',

    MERCHANTPAGE_PATH: '/cashback/fiche/',
    MERCHANTPAGE_TYPE_PATH: '/cashback/fiche/:type/',
    MERCHANTPAGE_ONLINE_PATH: '/cashback/fiche/en-ligne/',
    MERCHANTPAGE_EBON_PATH: '/cashback/fiche/bon-achat/',
    MERCHANTPAGE_OFFLINE_PATH: '/cashback/fiche/en-magasin/',

    FLASHING_TICKET_PAGE: '/envoi-ticket',

    CASHBACK_PATH: '/cashback',
    REDUCTION_PATH: '/reduction',
    CASHBACK_ONLINE: '/cashback/en-ligne',
    CASHBACK_EBON: '/cashback/bon-achat',
    CASHBACK_OFFLINE: '/cashback/en-magasin',

    CASHBACK_TYPE_MOST_POPULAR_PATH: '/cashback/:type/les-plus-populaires',
    CASHBACK_TYPE_ALPHA_PATH: '/cashback/:type/alphabetique/',
    CASHBACK_TYPE_CATEGORY_PATH: '/cashback/:type/categorie/',

    CASHBACK_ONLINE_MOST_POPULAR_PATH: '/cashback/en-ligne/les-plus-populaires',
    CASHBACK_ONLINE_ALPHA_PATH: '/cashback/en-ligne/alphabetique/',
    CASHBACK_ONLINE_CATEGORY_PATH: '/cashback/en-ligne/categorie/',

    CASHBACK_OFFLINE_MOST_POPULAR_PATH: '/cashback/en-magasin/les-plus-populaires',
    CASHBACK_OFFLINE_ALPHA_PATH: '/cashback/en-magasin/alphabetique/',
    CASHBACK_OFFLINE_CATEGORY_PATH: '/cashback/en-magasin/categorie/',

    CASHBACK_EBON_MOST_POPULAR_PATH: '/cashback/bon-achat/les-plus-populaires',
    CASHBACK_EBON_ALPHA_PATH: '/cashback/bon-achat/alphabetique/',
    CASHBACK_EBON_CATEGORY_PATH: '/cashback/bon-achat/categorie/',

    EBON_VALIDATION_PATH: '/bon-achat/validation',
    EBON_CONFIRMATION_PATH: '/selection-bons-d-achat/confirmation',
    EBON_ERROR_PATH: '/selection-bons-d-achat/erreur',
    EBON_DOWNLOAD_BILL_PATH: '/selection-bons-d-achat/commande/facture',

    KYC_CONFIRMATION_PATH: '/selection-bons-d-achat/confirmation/kyc',

    CASHBACK_MOST_POPULAR: '/cashback/les-plus-populaires',
    REDUCTION_MOST_POPULAR_PATH: '/reduction/les-plus-populaires',
    REDUCTION_ALPHA_PATH: '/reduction/alphabetique/',
    REDUCTION_CATEGORY_PATH: '/reduction/categorie/',
    ALPHA_PATH: 'alphabetique',
    CATEGORY_PATH: 'categorie',
    MOST_POPULAR_PATH: 'les-plus-populaires',

    NOT_FOUND_PATH: '/404'
};

export const EN = {
    HOME_PATH: '/',
    HOW_IT_WORK_PATH: '/how-it-works',

    FAQ_PATH: '/faq',
    LEGAL_NOTICE_PATH: '/legal-notice',
    TERMS_PATH: '/general-terms-conditions-use',
    TERMS_OF_SALES: '/general-terms-conditions-sale',
    CONTACTREQUEST_PATH: '/customer-service',
    UNSUBSCRIBE_PATH: '/unsubscribe',
    TOOLBAR_PATH: '/toolbar',
    TOOLBAR_POST_INSTALL_PATH: '/toolbar/post-install',
    MOBILE_APP_PATH: '/mobile-app',

    ACCOUNT_PATH: '/account',
    ACCOUNT_JACKPOT_PATH: '/account/gains',
    ACCOUNT_MESSAGES_PATH: '/account/my-messages',
    ACCOUNT_EBONS_PATH: '/account/my-gift-cards',
    ACCOUNT_PROFILE_PATH: '/account/my-profile',

    EBONS_REMINDER_PATH: '/my-gift-cards',

    ONLINE: 'online',
    OFFLINE: 'in-store',
    EBON: 'gift-card',

    INTERSTITIEL_CASHBACK_PATH: '/interstitial/cashback/',
    INTERSTITIEL_TOOLBAR_CASHBACK_PATH: '/toolbar/interstitial/cashback/',
    INTERSTITIEL_REDUCTION_PATH: '/interstitial/code-promo/',
    INTERSTITIEL_TOOLBAR_REDUCTION_PATH: '/toolbar/interstitial/code-promo/',

    MERCHANTPAGE_PATH: '/cashback/page/',
    MERCHANTPAGE_TYPE_PATH: '/cashback/page/:type/',
    MERCHANTPAGE_ONLINE_PATH: '/cashback/page/online/',
    MERCHANTPAGE_EBON_PATH: '/cashback/page/gift-card/',
    MERCHANTPAGE_OFFLINE_PATH: '/cashback/page/in-store/',

    FLASHING_TICKET_PAGE: '/send-ticket',

    CASHBACK_PATH: '/cashback',
    REDUCTION_PATH: '/discount',
    CASHBACK_ONLINE: '/cashback/online',
    CASHBACK_EBON: '/cashback/gift-card',
    CASHBACK_OFFLINE: '/cashback/in-store',

    CASHBACK_TYPE_MOST_POPULAR_PATH: '/cashback/:type/most-popular',
    CASHBACK_TYPE_ALPHA_PATH: '/cashback/:type/alphabetical/',
    CASHBACK_TYPE_CATEGORY_PATH: '/cashback/:type/category/',

    CASHBACK_ONLINE_MOST_POPULAR_PATH: '/cashback/online/most-popular',
    CASHBACK_ONLINE_ALPHA_PATH: '/cashback/online/alphabetical/',
    CASHBACK_ONLINE_CATEGORY_PATH: '/cashback/online/category/',

    CASHBACK_EBON_MOST_POPULAR_PATH: '/cashback/gift-card/most-popular',
    CASHBACK_EBON_ALPHA_PATH: '/cashback/gift-card/alphabetical/',
    CASHBACK_EBON_CATEGORY_PATH: '/cashback/gift-card/category/',

    EBON_VALIDATION_PATH: '/gift-card/validation',
    EBON_CONFIRMATION_PATH: '/gift-card-selection/confirmation',
    EBON_ERROR_PATH: '/gift-card-selection/error',
    EBON_DOWNLOAD_BILL_PATH: '/gift-card-selection/order/bill',

    KYC_CONFIRMATION_PATH: '/gift-card-selection/confirmation/kyc',

    CASHBACK_OFFLINE_MOST_POPULAR_PATH: '/cashback/in-store/most-popular',
    CASHBACK_OFFLINE_ALPHA_PATH: '/cashback/in-store/alphabetical/',
    CASHBACK_OFFLINE_CATEGORY_PATH: '/cashback/in-store/category/',

    CASHBACK_MOST_POPULAR: '/cashback/most-popular',
    REDUCTION_MOST_POPULAR_PATH: '/discount/most-popular',
    REDUCTION_ALPHA_PATH: '/discount/alphabetical/',
    REDUCTION_CATEGORY_PATH: '/discount/category/',
    ALPHA_PATH: 'alphabetical',
    CATEGORY_PATH: 'category',
    MOST_POPULAR_PATH: 'most-popular',

    NOT_FOUND_PATH: '/404'
};

export function getCurrentLocalePath() {
    if (USE_FRENCH_URL) {
        return FR;
    }
    return EN;
}

export const PATH = getCurrentLocalePath();



// WEBPACK FOOTER //
// ./src/constants/path.js